import CultureInfo from "../../culture-info";

export interface IDirtyTracking {
    isDirty: boolean;
    isTracking: boolean;
    startTracking(): void;
    markClean(): void;
}

export interface ICultureSensitiveDirtyTracking extends IDirtyTracking {
    getDirtyCultures(): Array<CultureInfo>;
}
